<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>User Profile</h2>
</div>
<nz-card>
  <div [ngClass]="!loading ? 'block' : 'hidden'">
    <div class="flex justify-between">
      <div class="flex flex-col sm:flex-row sm:items-center">
        <div class="relative w-[100px] h-[100px] sm:w-[125px] sm:h-[125px]">
          <div class="w-[100px] h-[100px] sm:w-[125px] sm:h-[125px]">
            <img class="rounded-full w-full h-full object-cover mt-0" nz-image nzSrc="{{this.uploadImageUrl}}"
            alt=""/>
          </div>

          <nz-upload [nzCustomRequest]="customUploadReq"
                     [nzShowUploadList]="false"
                     [nzMultiple]="false">
          <span nz-icon nzType="edit" nzTheme="outline"
                class=" bg-primary rounded-full absolute bottom-2.5 right-0.5 sm:bottom-2 sm:right-2 text-white p-1 w-6 h-6 cursor-pointer">
          </span>
          </nz-upload>
        </div>
        <p *ngIf="imageUploading" class="text-primary mx-4">Uploading ...</p>


        <nz-divider nzType="vertical" class="hidden sm:block h-full"></nz-divider>

        <div class="mt-3 sm:mt-0">
          <div class="flex items-center">
            <h6 class="text-primary ">{{userData?.firstname + " " + userData?.lastname}}</h6>
            <span nz-icon nzType="edit" nzTheme="outline" class="mx-2 text-base cursor-pointer"
                  (click)="showNameEditModal('name')"></span>
          </div>
          <p>{{userData?.staffNumber}} | {{userData?.role?.name | titlecase}}</p>
        </div>
      </div>
      <div>
        <nz-tag *ngIf="userData?.active" [nzColor]="'#3ab200'" class="rounded-full text-base">Active</nz-tag>
        <nz-tag *ngIf="!userData?.active" [nzColor]="'#ff4d4f'" class="rounded-full text-base">Inactive</nz-tag>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div class="grid md:grid-cols-2">
      <div>
       <div class="mb-4">
         <h6 class="text-primary mb-1">Contact Details</h6>
         <div>
           <div class="flex flex-col min-[450px]:flex-row">
             <p class="mr-1">Email: </p>
             <p class="text-black font-medium">{{userData?.email}}</p>
           </div>
           <div class="flex flex-col min-[450px]:flex-row">
             <p class="mr-1">Mobile Number:</p>
             <p class="text-black font-medium">{{userData?.mobile}}<span nz-icon nzType="edit"
                                                                         nzTheme="outline"
                                                                         class="mx-2 text-base cursor-pointer"
                                                                         (click)="showNameEditModal('mobile')"></span></p>
           </div>
         </div>
       </div>
        <div>
          <h6 class="text-primary mb-1">Other Information</h6>
          <p class="mb-2">Department{{userData?.department?.length === 1 ? '' : 's'}}:
            <span  *ngFor="let dep of userData?.department">
              <span class="text-black font-medium" *ngIf="userData?.department?.length === 1">
               {{dep.company ? dep.department.name + "-" + dep.company.name : dep.department.name}}
              </span>
            </span>
          </p>
          <div *ngFor="let dep of userData?.department">
                <span class="text-black font-medium" *ngIf="(userData?.department?.length > 1)">
                {{dep.company ? dep.department.name + "-" + dep.company.name : dep.department.name}}
              </span>
          </div>
        </div>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div id="pwsChange" class="grid md:grid-cols-2">
      <div>
        <h6 class="text-primary">Change Password</h6>
        <form nz-form [formGroup]="changePswForm" [nzLayout]="'vertical'">
          <div class="flex flex-col ">
            <nz-form-item class="grid grid-flow-row mt-5">
              <nz-form-label>Old Password</nz-form-label>
              <nz-form-control [nzErrorTip]="oldPasswordError">
                <nz-input-group [nzSuffix]="oldPasswordSuffixTemplate">
                  <input nz-input [type]="oldPswVisible ? 'password' : 'text'" formControlName="oldPassword"
                         placeholder="Enter Old Password"/>
                </nz-input-group>
                <ng-template #oldPasswordSuffixTemplate>
                  <i class="cursor-on" nz-icon [nzType]="oldPswVisible ? 'eye-invisible' : 'eye'"
                     (click)="oldPswVisible = !oldPswVisible"></i>
                </ng-template>
              </nz-form-control>
              <ng-template #oldPasswordError>
                <span *ngIf="formErrors.oldPassword.required">Enter old password</span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row">
              <nz-form-label>New Password</nz-form-label>
              <nz-form-control [nzErrorTip]="newPasswordError">
                <nz-input-group [nzSuffix]="newPasswordSuffixTemplate">
                  <input nz-input [type]="newPswVisible ? 'password' : 'text'" formControlName="password"
                         placeholder="Enter New Password"/>
                </nz-input-group>
                <ng-template #newPasswordSuffixTemplate>
                  <i class="cursor-on" nz-icon [nzType]="newPswVisible ? 'eye-invisible' : 'eye'"
                     (click)="newPswVisible = !newPswVisible"></i>
                </ng-template>
              </nz-form-control>
              <ng-template #newPasswordError>
                <span *ngIf="formErrors.password.required">Enter new password</span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row">
              <nz-form-label>Confirm Password</nz-form-label>
              <nz-form-control [nzErrorTip]="confirmPasswordError">
                <nz-input-group [nzSuffix]="confirmPasswordSuffixTemplate">
                  <input nz-input [type]="confirmPswVisible ? 'password' : 'text'" formControlName="confirmPassword"
                         placeholder="Enter Confirm Password"/>
                </nz-input-group>
                <ng-template #confirmPasswordSuffixTemplate>
                  <i class="cursor-on" nz-icon [nzType]="confirmPswVisible ? 'eye-invisible' : 'eye'"
                     (click)="confirmPswVisible = !confirmPswVisible"></i>
                </ng-template>
              </nz-form-control>
              <ng-template #confirmPasswordError>
                <span *ngIf="formErrors.confirmPassword.required">Enter confirm password</span>
                <span *ngIf="!isSamePwd">Password is not same</span>
              </ng-template>
            </nz-form-item>
          </div>
        </form>
        <div class="flex justify-end">
          <button nz-button nzType="primary" [disabled]="changePswForm.invalid" (click)="changePwd()">Change Password</button>
        </div>
        <nz-alert *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type" [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>
      </div>
    </div>
  </div>

  <div [ngClass]="loading ? 'block' : 'hidden'">
    <app-single-view-skeleton-template [typeName]="'user-profile-view'"></app-single-view-skeleton-template>
  </div>
</nz-card>

<nz-modal [(nzVisible)]="isVisibleEditName"
          (nzOnCancel)="handleCancelEditName()"
          nzTitle="{{editDataType === 'name' ? 'Edit Name' : 'Edit Mobile Number' }}">
  <div *nzModalContent>
    <div class="" *ngIf="editDataType === 'name'">
      <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
        <div>
          <p class="font-bold">First Name: </p>
          <input nz-input type="text" [(ngModel)]="firstname" placeholder="Enter First Name"/>
          <span *ngIf="!firstname.length" class="text-sm" style="color: #ff4d4f">Please enter first name</span>
        </div>
        <div>
          <p class=" font-bold">Last Name: </p>
          <input nz-input type="text" [(ngModel)]="lastname" placeholder="Enter Last Name"/>
          <span *ngIf="!lastname.length" class="text-sm" style="color: #ff4d4f">Please enter last name</span>
        </div>
      </div>
      <div class="flex justify-end mt-5">
        <button nz-button nzType="primary" (click)="saveData('name')"
                [disabled]="(!firstname.length || !lastname.length)"
                [nzLoading]="editDataButtonLoading">Save
        </button>
      </div>
    </div>

    <div class="" *ngIf="editDataType === 'mobile'">
      <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
        <div>
          <p class="font-bold">Mobile Number: </p>
          <input nz-input type="text" [(ngModel)]="mobile" placeholder="Enter Mobile Number"/>
          <span *ngIf="!mobile.length" class="text-sm" style="color: #ff4d4f">Please enter mobile number </span>
          <span *ngIf="validateMobile(mobile)" class="text-sm" style="color: #ff4d4f">Invalid mobile number </span>
        </div>
      </div>
      <div class="flex justify-end mt-2">
        <button nz-button nzType="primary" (click)="saveData('mobile')"
                [disabled]="((!mobile.length) || validateMobile(mobile))"
                [nzLoading]="editDataButtonLoading">Save
        </button>
      </div>
    </div>
  </div>
  <div *nzModalFooter>
    <!--    <span>Modal Footer:</span>-->
    <!--    <button nz-button nzType="default" (click)="handleCancelEditName()">Custom Callback</button>-->
    <!--    <button nz-button nzType="primary" (click)="handleOkEditName()" [nzLoading]="isConfirmLoading">Custom Submit</button>-->
  </div>
</nz-modal>
